import { render, staticRenderFns } from "./NoData2.vue?vue&type=template&id=072b2666&scoped=true"
import script from "./NoData2.vue?vue&type=script&lang=js"
export * from "./NoData2.vue?vue&type=script&lang=js"
import style0 from "./NoData2.vue?vue&type=style&index=0&id=072b2666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072b2666",
  null
  
)

export default component.exports